import { Box, makeStyles, Typography } from '@material-ui/core'
import { groupBy } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { reloadFacilities } from '../../../actions/facilities/facilities.actions'
import FacilityDashNotifications from '../../../components/Cards/Facility/FacilityDashNotifications'
import FriendsOfSkiptownSectionFields from '../../../components/Cards/Facility/FriendsOfSkiptownSectionFields'
import MarketingContentSection from '../../../components/Cards/Facility/MarketingContentSection'
import { CATEGORIES } from '../../../components/Cards/Facility/marketingContentConfig'
import { BAR_ITEM, EVENT, PARTNERSHIP } from '../../../utils/marketing'
import StyledAlert from '../../../components/Common/StyledAlert'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import useSelectedFacility from '../../../hooks/useSelectedFacility'
import Promotions from '../Promotions/Promotions'

const useStyles = makeStyles(() => ({
	container: { padding: 24, marginBottom: 20 },
	pageHeading: { fontWeight: 800, marginBottom: 24, fontSize: '1.5rem' }
}))

const SECTION_CATEGORY = {
	events: EVENT,
	bar: BAR_ITEM,
	friendsOfSkiptown: PARTNERSHIP
}

const EXTRA_SECTIONS = {
	dashNotifications: true,
	promos: true
}

const FacilityMarketing = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()

	const { facility, loading } = useSelectedFacility()

	const category = SECTION_CATEGORY[params.section]
	const isExtraSection = Boolean(EXTRA_SECTIONS[params.section])

	const [byCategory, setByCategory] = useState(null)

	// Guards a direct hit on /facilities/null/... — the route matches, so every write would
	// otherwise fail on a cast error.
	const facilityId = params.facilityId
	const hasFacilityId = Boolean(facilityId) && facilityId !== 'null' && facilityId !== 'undefined'

	useEffect(() => {
		dispatch(reloadFacilities())
	}, [dispatch])

	useEffect(() => {
		if (!hasFacilityId || !facility) {
			return
		}

		const grouped = groupBy(facility.marketing_content || [], 'category')
		const seeded = {}
		for (const cat of CATEGORIES) {
			seeded[cat] = grouped[cat] || []
		}
		setByCategory(seeded)
	}, [hasFacilityId, facility])

	const records = byCategory && category ? byCategory[category] : null
	const setRecords = (next) => setByCategory((prev) => ({ ...prev, [category]: next }))

	if (!hasFacilityId) {
		return (
			<Box className={classes.container}>
				<StyledAlert
					type="error"
					text="No facility selected. Choose a facility and open Facility Marketing again."
				/>
			</Box>
		)
	}

	if (!category && !isExtraSection) {
		return (
			<Box className={classes.container}>
				<StyledAlert type="error" text="That marketing section does not exist." />
			</Box>
		)
	}

	return (
		<Box>
			{params.section === 'dashNotifications' ? (
				<Box className={classes.container}>
					<Typography className={classes.pageHeading}>Dash Notifications</Typography>
					<FacilityDashNotifications facilityId={facilityId} />
				</Box>
			) : null}

			{params.section === 'promos' ? <Promotions /> : null}

			{records ? (
				<Box className={classes.container}>
					{category === PARTNERSHIP ? (
						<>
							<Typography className={classes.pageHeading}>Friends of Skiptown</Typography>
							<FriendsOfSkiptownSectionFields facility={facility} facilityId={facilityId} />
						</>
					) : null}
					<MarketingContentSection
						category={category}
						facilityId={facilityId}
						records={records}
						onChange={setRecords}
						titleStyles={category === PARTNERSHIP ? { fontSize: '1.2rem' } : null}
					/>
				</Box>
			) : null}
			{loading ? <LoadingOverlay /> : null}
		</Box>
	)
}

export default FacilityMarketing
